import React from "react";
import {Box, LinearProgress, Stack, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";

export const CardItem = ({icon, title, subtitle, secondary, percent }) => {

    return (
        <Stack
            sx={{flex: 1, p: 2, borderRadius: 3, boxShadow: 3}}
            direction={"row"} gap={2}
            flexWrap={"wrap"}
            justifyContent={"space-between"} alignItems={"center"}
        >
            {icon}
            <Box sx={{flex: 1}}>
                <Typography variant={"h4"} fontWeight={"bold"}>{title}</Typography>
                {subtitle && <Typography variant={"subtitle2"} sx={{color: grey[500]}}>{subtitle}</Typography>}
            </Box>
            {secondary}
            {
                percent &&
                <Box sx={{width: '100%', display: "block"}}>
                    <LinearProgress variant={"determinate"} color={"success"} value={percent} sx={{pt: 1}} />
                </Box>
            }
        </Stack>
    )
}
